import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ErrorBoundary from './ErrorBoundary';

export const ProtectedRoute = ({ children, allowedRoles, denyOffice }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-secure">
        <div className="spinner" />
        <p className="mt-4 text-muted-foreground">Sécurisation de vos données...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.status === 'pending_first_login' && location.pathname !== '/first-login') {
    return <Navigate to="/first-login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    switch (user?.role) {
      case 'super_admin':
      case 'admin_ops':
      case 'bureau':
        return <Navigate to="/admin" replace />;
      case 'analyst':
        return <Navigate to="/analyst" replace />;
      case 'client':
        return <Navigate to="/client" replace />;
      default:
        return <Navigate to="/login" replace />;
    }
  }

  // Block office-bound admins from certain routes
  if (denyOffice && ['admin_ops','bureau'].includes(user?.role) && user?.office_id) {
    return <Navigate to="/admin" replace />;
  }

  return <ErrorBoundary key={location.pathname}>{children}</ErrorBoundary>;
};

export default ProtectedRoute;
